import { useUserSegmentsIncludes } from '@namespace/segments';

export const usePromotionGamesResolvedCategory = ({
  segmentedFeeds,
  defaultFeedCategory
}) => {
  const isUserSegmentsIncludes = useUserSegmentsIncludes();

  const matchedSegmentedFeed = segmentedFeeds.find((segmentedFeed) =>
    isUserSegmentsIncludes(segmentedFeed.userSegments)
  );

  if (segmentedFeeds.length > 0 && matchedSegmentedFeed) {
    return matchedSegmentedFeed?.category ?? defaultFeedCategory;
  }

  return defaultFeedCategory;
};
